/*
Route error boundary. Renders the error state and reports the hit to Matomo
(see ErrorPageTracking) — inline usages of ErrorState stay untracked.
*/

'use client';

import ErrorPageTracking from '@/components/base/ErrorPageTracking';
import ErrorState from '@/components/base/ErrorState';

export default function ErrorBoundary({ reset }: { reset: () => void }) {
  return (
    <>
      <ErrorPageTracking errorType="500" />
      <ErrorState reset={reset} />
    </>
  );
}
